import { combineReducers } from '@reduxjs/toolkit'
import sessionReducers from './sessionReducers'
import leadReducer from './leadReducers'


const rootReducer = combineReducers({
  sessions: sessionReducers,
   leads: leadReducer,
})

export default rootReducer